module.exports = __webpack_public_path__ + "static/media/linear-calendar.f4d7206f.svg";